import styled from 'styled-components';
import { Heading2, Heading4 } from '../../Typography/Heading';
import { windowMaxWidth } from '../breakpoints';

// Styles for the WorklistList component

const WorklistWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

const WorklistReminderTitle = styled(Heading4)`
  margin-left: 10px;
  margin-top: 0;
`;

const WorklistReminderMessageWrapper = styled.div`
  position: relative;
`;

const WorklistReminderMessageCounter = styled.div`
  background-color: var(--greyscale-concrete);
  border-radius: var(--border-radius-medium);
  color: var(--greyscale-white);
  cursor: default;
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-small);
  padding: 2px 10px;
  position: absolute;
  right: 10px;
  top: 90px;
`;

const WorklistReminderFooterWrapper = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

// Styles for the WorklistHeader component

const WorklistHeaderWrapper = styled.div`
  background-color: var(--greyscale-white);
  border-bottom: 1px solid var(--greyscale-dark-white);
  display: flex;
  flex-direction: column;
  height: 101px;
  padding: 20px;

  &.no-border {
    border-bottom: none;
    height: 99px;
  }
`;

const WorklistHeaderButtonsSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const WorklistHeaderLeftButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

const WorklistHeaderRightButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

const WorklistHeaderTitleSection = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;

  svg {
    margin-right: 5px;
  }
`;

const WorklistHeaderIcon = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  height: 24px;
  justify-content: center;
  width: 24px;
`;

const WorklistHeaderTitle = styled(Heading2)`
  flex: 0 1 auto;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const WorklistHeaderUnreadCounterBubble = styled.span`
  align-items: center;
  background-color: var(--primary-oqio-blue);
  border-radius: var(--border-radius-medium);
  color: var(--greyscale-white);
  display: flex;
  flex: 0 1 20px;
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  height: 20px;
  justify-content: center;
  line-height: var(--font-line-height-small);
  margin-left: 5px;
  padding: 2px 6px;
`;

const WorklistHeaderWarningWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const WorklistHeaderWarningContentWrapper = styled.div`
  align-items: center;
  background-color: var(--primary-oqio-red);
  display: flex;
  flex-direction: row;
  height: 40px;
  justify-content: flex-start;
  padding: 10px 30px;
  transition: background-color 0.1s;

  &:hover {
    background-color: var(--primary-oqio-red-hover);
    cursor: pointer;
  }

  @media (${windowMaxWidth.mobile}) {
    height: 52px;
  }
`;

const WorklistHeaderWarningMessage = styled.span`
  color: var(--greyscale-white);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-small);
  padding-left: 10px;
`;

const WorklistHeaderWarningIcon = styled.span`
  align-items: center;
  display: flex;

  svg {
    path:not(.dot) {
      stroke: var(--greyscale-white);
    }

    path.dot {
      fill: var(--greyscale-white);
    }
  }
`;

// Styles for the WorklistMessageReminder component

const WorklistMessageReminderModalContentWrapper = styled.div`
  padding: 20px;
`;

// Styles for the WorklistList component

const WorklistListWrapper = styled.div`
  height: calc(100% - 100px);
  margin: 0;
  overflow: auto;
  position: relative;
  scrollbar-color: rgb(136 136 136 / 30%) transparent;
  scrollbar-width: thin;
`;

const WorklistListList = styled.ul`
  margin: 0;
`;

const WorklistListLoadingWrapper = styled.div`
  align-items: center;
  background-color: var(--greyscale-white);
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;

const WorklistListEmptyStateWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;

const WorklistListEmptyStateContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 20px;
`;

const WorklistListEmptyStateHeader = styled(Heading4)``;

const WorklistListEmptyStateMessage = styled.span`
  font-size: var(--font-size-regular);
`;

const WorklistListLayout = {
  WorklistWrapper,
  WorklistReminderTitle,
  WorklistReminderMessageWrapper,
  WorklistReminderMessageCounter,
  WorklistReminderFooterWrapper,
  WorklistHeaderWrapper,
  WorklistHeaderButtonsSection,
  WorklistHeaderLeftButtonWrapper,
  WorklistHeaderRightButtonWrapper,
  WorklistHeaderTitleSection,
  WorklistHeaderIcon,
  WorklistHeaderTitle,
  WorklistHeaderUnreadCounterBubble,
  WorklistMessageReminderModalContentWrapper,
  WorklistListWrapper,
  WorklistListList,
  WorklistListLoadingWrapper,
  WorklistListEmptyStateWrapper,
  WorklistListEmptyStateContentWrapper,
  WorklistListEmptyStateHeader,
  WorklistListEmptyStateMessage,
  WorklistHeaderWarningWrapper,
  WorklistHeaderWarningContentWrapper,
  WorklistHeaderWarningMessage,
  WorklistHeaderWarningIcon
};

export default WorklistListLayout;
